<template lang="pug">

  v-app-bar(color="transparent" :height="75" absolute flat app)

    v-btn(
      v-if="!$vuetify.breakpoint.mdAndUp"
      @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)"
      :class="{ 'pa-0': $vuetify.breakpoint.mdAndUp }"
      small
      fab
    ).pa-0

      v-icon(v-if="drawer")
        | mdi-view-quilt
      v-icon(v-else)
        | mdi-dots-vertical

    v-toolbar-title(class="pl-2" v-if="!$vuetify.breakpoint.mdAndUp")
      | Menu

    v-spacer

    .mx-3

    v-menu(min-width="200" origin="top right" transition="scale-transition" offset-y bottom left)

      template(v-slot:activator="{ attrs, on }")

        v-btn(class="align-self-center ma-0 pa-0" min-width="0" v-bind="attrs" v-on="on" text)

          v-list-item-avatar(class="align-self-center ma-0 pa-0" color="grey")
            v-img(:src="userSession.userProfile.img")

      v-list(style="padding: 0; margin: 0; display: flex; align-items: center;" :tile="false" flat nav)

        app-bar-logout-item(:key="`item-logout`" style="padding: 0; margin: 0;")

          v-list-item-title(style="height: 100%; padding: 10px" v-text="'Sair'" @click.stop.prevent="sairGestor")

</template>

<script>

  import { mapState, mapMutations } from 'vuex'
  import { VHover, VListItem } from 'vuetify/lib'

  export default {
    name: 'AppBar',

    components: {
      AppBarLogoutItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    /* data: () => ({
      logout: {
        title: 'Sair',
      },
    }), */

    computed: {
      ...mapState({
        drawer: state => state.app.drawer,
        userSession: state => state.app.userSession,
      }),
    },

    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),

      sairGestor: function () {
        // [24/01/25] console.log(':::: CLICOU PARA SAIR NO MENU SUPERIOR (canto direito)')

        this.$store.commit('ASK_LOGOUT')
      },
    },
  }

</script>
